<template>
    <b-input-group>
        <b-form-input
            v-model="value"
            :type="schema.inputType == 'password' ? (showPassword ? 'text' : 'password') : schema.inputType"
            :autocomplete="schema.inputType == 'password' ? 'new-password' : 'off'"
            v-bind="{ ...schema, ...schema.attributes }" />
        <b-input-group-append v-if="schema.inputType === 'password'">
            <b-button @click="showPassword = !showPassword">
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </b-button>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
    import { abstractField } from "vue-form-generator";
    export default {
        mixins: [abstractField],
        data() {
        return {
                showPassword: false
            }
        }
    };
</script>

<style></style>
